// extracted by mini-css-extract-plugin
export default {"media":"Media_media__W1e9r","noBorder":"Media_noBorder__mB3Up"};